module.exports = __webpack_public_path__ + "nc_static/media/card_download.45ff0896.svg";